import React, { memo } from "react";
import useSubscribedAndReachedPerEventBarChart from "./index.hooks";
import { ResponsiveBar } from "@nivo/bar";
import { AppPaper } from "../index";
import { Typography } from "@material-ui/core";

type SubscribedAndReachedPerEventBarChartProps = {};

const SubscribedAndReachedPerEventBarChart = ({}: SubscribedAndReachedPerEventBarChartProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    data,
    t,
  } = useSubscribedAndReachedPerEventBarChart();

  return (
    <AppPaper className={styles.chartPaper}>
      <Typography>{t("Devices Subscribed And Reached")}</Typography>
      <ResponsiveBar
        data={data}
        keys={["subscribed", "reached"]}
        indexBy={"title"}
        margin={{ top: 50, right: 130, bottom: 60, left: 60 }}
        padding={0.3}
        groupMode="grouped"
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "events",
          legendPosition: "middle",
          legendOffset: 32,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "devices",
          legendPosition: "middle",
          legendOffset: -40,
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
      />
    </AppPaper>
  );
};

export default memo(SubscribedAndReachedPerEventBarChart);
